<template>
  <div>
    <h2 class="title">Confirmation</h2>
    <pre>{{ wizardData }}</pre>

    <button class="button is-light" @click="$emit('prev')">Back</button>
    <button class="button is-success" @click="$emit('finish')">Finish</button>
  </div>
</template>

<script>
export default {
  props: ['wizardData'],
};
</script>
